import React, { useState, useEffect, useRef } from "react";
import { Typography, Box } from "@mui/material";
import { TimerOutlined } from "@mui/icons-material";


// Only a finite positive number starts a countdown. Missing/invalid backend
// values (null, undefined, NaN, 0, negative) return null so the timer renders
// nothing and — importantly — never fires onExpire for them.
function normalizeRemainingSeconds(value) {
  if (typeof value !== "number" || !Number.isFinite(value) || value <= 0) {
    return null;
  }
  return Math.floor(value);
}

export default function PaymentTimer({ remainingSeconds, onExpire }) {
  const [timeLeft, setTimeLeft] = useState(
    () => normalizeRemainingSeconds(remainingSeconds) ?? 0,
  );
  const hasExpiredRef = useRef(false);
  // True once a real backend countdown was received, so reaching 0 means
  // "genuinely expired" rather than "no data".
  const hadValidCountdownRef = useRef(
    normalizeRemainingSeconds(remainingSeconds) !== null,
  );
  const targetEndTimeRef = useRef(
    normalizeRemainingSeconds(remainingSeconds) !== null
      ? Date.now() + normalizeRemainingSeconds(remainingSeconds) * 1000
      : null,
  );
  const onExpireRef = useRef(onExpire);

  // Keep the latest callback without tearing down the interval.
  useEffect(() => {
    onExpireRef.current = onExpire;
  }, [onExpire]);

  const isActive = timeLeft > 0;

  // 2. Update the re-sync effect to update targetEndTimeRef:
  useEffect(() => {
    const seconds = normalizeRemainingSeconds(remainingSeconds);
    if (seconds === null) {
      hadValidCountdownRef.current = false;
      targetEndTimeRef.current = null;
      setTimeLeft(0);
      return;
    }
    hasExpiredRef.current = false;
    hadValidCountdownRef.current = true;
    targetEndTimeRef.current = Date.now() + seconds * 1000; // <--- Updates target timestamp
    setTimeLeft(seconds);
  }, [remainingSeconds]);

  // 3. Update the interval effect to read from targetEndTimeRef.current:
  useEffect(() => {
    if (!isActive) return undefined;

    const timer = setInterval(() => {
      if (!targetEndTimeRef.current) return;
      const secondsLeft = Math.max(
        0,
        Math.ceil((targetEndTimeRef.current - Date.now()) / 1000),
      );
      setTimeLeft(secondsLeft);
    }, 1000);

    return () => clearInterval(timer);
  }, [isActive]);

  // Notify once when a genuine countdown reaches zero.
  useEffect(() => {
    if (
      timeLeft === 0 &&
      hadValidCountdownRef.current &&
      !hasExpiredRef.current
    ) {
      hasExpiredRef.current = true;
      onExpireRef.current?.();
    }
  }, [timeLeft]);
  if (!isActive) return null;

  const isUrgent = timeLeft <= 60;
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

  return (
    // <Box
    //   display="flex"
    //   alignItems="center"
    //   gap={0.5}
    //   sx={{
    //     color: isUrgent ? "error.main" : "warning.dark",
    //     transition: "color 0.3s ease-in-out",
    //     ...(isUrgent && {
    //       animation: "timerPulse 1.2s infinite ease-in-out",
    //     }),
    //     "@keyframes timerPulse": {
    //       "0%": { opacity: 1 },
    //       "50%": { opacity: 0.4 },
    //       "100%": { opacity: 1 },
    //     },
    //   }}
    // >
    //   <TimerOutlined fontSize="small" />
    //   <Typography variant="body2" fontWeight={700} dir="ltr">
    //     {formattedTime}
    //   </Typography>
    //   <Typography variant="caption" fontWeight={600}>
    //     تا انقضای سفارش
    //   </Typography>
    // </Box>
    <></>
  );
}
